import Work from "./Work";
import Education from "./Education";

function AboutMe() {
  return (
    <div className="about-me-section">
      <h2 className="section-title">Background</h2>
      <div className="about-content">
        <div className="about-subsection">
          <Work />
        </div>
        <div className="about-subsection">
          <Education />
        </div>
      </div>
    </div>
  );
}

export default AboutMe;

